import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

export const App = React.lazy(() => import('./App').then((res) => ({ default: res.App })));

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Suspense>
            <App />
        </Suspense>
    </React.StrictMode>
);
